export function orderPrice(unit, price) {
  return unit * price;
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

//to detect Url
export function detectURLs(message) {
  var urlRegex = /(((https?:\/\/)|(support\.)| (www\.))[^\s]+)/g;
  return message.match(urlRegex);
}

//Format a json string to defined sentence
export const formatJsonToString = (json) => {
  try {
    let parsedJson = JSON.parse(json);
    let string = "";

    parsedJson &&
      Object.keys(parsedJson).map((value) => {
        return (string = string + value + ": " + parsedJson[value] + "\n");
      });

    return string;
  } catch (error) {
    return json;
  }
};
